import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const isLogged = () => sessionStorage.getItem('@fruit_people-token');

export const AuthRoute = (props: any) =>
  isLogged() ? <Route {...props} /> : <Redirect to="/" />;
